import { render, staticRenderFns } from "./SaveQueryModal.vue?vue&type=template&id=68bf7549&scoped=true"
import script from "./SaveQueryModal.vue?vue&type=script&lang=js"
export * from "./SaveQueryModal.vue?vue&type=script&lang=js"
import style0 from "./SaveQueryModal.vue?vue&type=style&index=0&id=68bf7549&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf7549",
  null
  
)

export default component.exports